import { z } from 'zod';
import { meta } from '../meta';

export const VideoPropsSchema = z.object({
  src: z.string().default('').meta(meta({ label: '视频', setter: 'video' })),
  poster: z.string().default('').meta(meta({ label: '封面', setter: 'image' })),
  autoplay: z.boolean().default(false).meta(meta({ label: '自动播放', setter: 'switch' })),
  loop: z.boolean().default(false).meta(meta({ label: '循环', setter: 'switch' })),
  muted: z.boolean().default(true).meta(meta({ label: '静音', setter: 'switch' })),
  controls: z.boolean().default(true).meta(meta({ label: '显示控件', setter: 'switch' })),
});

export type VideoProps = z.infer<typeof VideoPropsSchema>;
